import React from 'react';
import { Button, Table } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import customer from '../../../../shared/data/customer.json';
import Empty from '../../../../shared/components/Empty/Index';

import './styles.css';

export default function Items(props) {
    return (
        <Table
            rowKey="id"
            size='small'
            dataSource={customer}
            locale={{ emptyText: <Empty /> }}
            pagination={{
                showSizeChanger: false,
                showTotal: (total) => `${total} Registro(s) encontrado(s).`
            }}
            columns={[
                {
                    title: '',
                    align: 'center',
                    width: 60,
                    render: (item) => {
                        return (
                            <div className='inline-flex'>
                                <Button
                                    style={{ padding: '0px 6px', height: 'auto' }}
                                    onClick={() => props.onEdit(item)}>
                                    <EditOutlined />
                                </Button>
                            </div>
                        );
                    }
                },
                {
                    title: 'Nombre',
                    key: 'name',
                    render: (item) => (item.name + ' ' + (item.lastName ?? ''))
                },
                {
                    title: 'Télefono',
                    width: 130,
                    align: 'center',
                    key: 'phoneNumber',
                    dataIndex: 'phoneNumber'
                },
                {
                    title: 'Nacimiento',
                    width: 120,
                    align: 'center',
                    key: 'birthDate',
                    dataIndex: 'birthDate'
                },
                {
                    title: 'Dirección',
                    key: 'address',
                    dataIndex: 'address'
                }
            ]}
        />
    );
}